import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { injectSpeedInsights } from '@vercel/speed-insights';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { IS_ISOLATE_MODE } from './app/app.module';  // Import the token from app.module
import { APP_INITIALIZER } from '@angular/core';

if (environment.production) {
  enableProdMode();
}

if (environment.vercelAnalytics) { injectSpeedInsights(); }

const initApp = (module) => {
  platformBrowserDynamic().bootstrapModule(module)
    .catch(err => console.error(err));
};

// Check if we are in isolated mode
const isIsolateMode = location.search.includes("isolate=1");

// Create a function to provide the isolate mode value
function provideIsIsolateMode() {
  return isIsolateMode;
}

platformBrowserDynamic([
  { provide: IS_ISOLATE_MODE, useFactory: provideIsIsolateMode },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => {
      console.log(`Application initialized in ${isIsolateMode ? 'isolated' : 'normal'} mode.`);
    },
    deps: [IS_ISOLATE_MODE],
    multi: true
  }
]).bootstrapModule(AppModule)
  .catch(err => console.error(err));
